import { AnySourceStream, Stream } from '../stream'
import { shallowClone } from '@hypatia/utils/object/shallow-clone'
import { Pass } from './pass'

export class Clone<V = any, E = any, C = any> extends Pass<V, E, C, V> {
    value(value: V) {
        this._value(shallowClone(value))
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        clone(): MirrorStream<DV, DE, DC>
    }
}

Stream.prototype.clone = function <SV, SE, SC>(this: AnySourceStream<SV, SE, SC>) {
    return new Clone(this) // tslint:disable-line:no-invalid-this
}
